module.exports = __webpack_public_path__ + "img/area_5.817c086a.png";